import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import stage from '../components/stage'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper'





class Menu extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      location: [],
      slider: null,
      categories: null,
      download: null
    }

  }

  mount() {


    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);

    this.resizeQue()



    this.swiper = new Swiper(this.ref.slider, {
      zoom: {
        maxRatio: 3
      },
      pagination: {
        el: ".menu__slider-pagination",
        clickable: true
      }
    });




     _each(this.ref.location, (item) => {

     // console.log(item);

       $(item).on('click', (e) => {
         
        
        e.preventDefault()

         if (e.currentTarget.classList.contains('menu__location--selected')) {
          return
         }
          
         this.ref.categories.classList.add('is-loading')
         this.ref.slider.classList.add('is-loading')

         $('.menu__location--selected').removeClass('menu__location--selected')
         $(e.currentTarget).addClass('menu__location--selected')

        
        
        const loc = document.getElementById(`${item.dataset.location}1`)
        const fragment = loc.content.cloneNode(true)
        const elm = fragment.querySelectorAll('.slide')

        const action = document.getElementById(`${item.dataset.location}1link`)
        const actionfragment = action.content.cloneNode(true)

        this.ref.download.innerHTML = ""
        this.ref.download.append(actionfragment)


        const cat = document.getElementById(`menu${item.dataset.location}`)
        const catfragment = cat.content.cloneNode(true)


        this.ref.categories.innerHTML = ""
        this.ref.categories.append(catfragment)


        this.swiper.removeAllSlides()
        this.swiper.appendSlide([...elm])

        gsap.delayedCall(.3, ()=>{
            this.ref.categories.classList.remove('is-loading')
            this.ref.slider.classList.remove('is-loading')
        })
      

       })

     })


     $('.menu__categories').on('click', 'a', (e)=>{
        e.preventDefault()
        const el = e.currentTarget

        if (el.classList.contains('selected')) {
          return
        }

        $('.menu__categories .selected').removeClass('selected')
        $(e.currentTarget).addClass('selected')

        this.ref.slider.classList.add('is-loading')

        const loc = document.getElementById(`${el.dataset.location}`)
        const fragment = loc.content.cloneNode(true)
        const elm = fragment.querySelectorAll('.slide')

        this.swiper.removeAllSlides()
        this.swiper.appendSlide([...elm])

        const action = document.getElementById(`${el.dataset.location}link`)
        const actionfragment = action.content.cloneNode(true)

        this.ref.download.innerHTML = ""
        this.ref.download.append(actionfragment)

         gsap.delayedCall(.3, () => {
          
           this.ref.slider.classList.remove('is-loading')
         })
     })


      
}



resize(){

    const box = this.element.getBoundingClientRect()
    const offset = (stage.h - box.height) > 0 ? 0 : stage.h - box.height
    
    this.element.style.setProperty('--bottom-offset', offset + "px");

}

  unmount() {



    stage.removeAllListeners()
    this.swiper.destroy()

    _each(this.ref.location, (item) => {
      $(item).off('click')
    })

  }


}

module.exports = Menu
